import React, { ReactNode } from 'react';
import { IcoMoonIcon } from '@wwe-portal/ui/components/icons';
import { LeaderboardReward } from '@wwe-portal/entities/rbe.type';

import { RewardItemContainer } from '@wwe-portal/ui/features/reward/reward-item-container';
import { cn } from '@wwe-portal/ui/lib/lib';
import { PickemIcon } from '../../components/icons/pickem';

const PortalCurrencyItemImage = ({
  rewardItem,
  className,
}: {
  rewardItem: Partial<LeaderboardReward>;
  className?: string;
}) => {
  const iconClassName = cn('h-full w-full object-contain', className);
  switch (rewardItem.rewardCurrency) {
    case 'Web Coin':
      return (
        <IcoMoonIcon iconName="web-coin-circle" className={iconClassName} />
      );
    case 'Ruby':
      return <IcoMoonIcon iconName="diamond-fill" className={iconClassName} />;
    case 'Pickem':
      return <PickemIcon className={iconClassName} />;
  }
  return null;
};

export const RewardItemUI = ({
  rewardItem,
  size = 'default',
  position = 'default',
  itemClassName,
  containerClassName,
  inGameItem,
}: {
  rewardItem?: Partial<LeaderboardReward>;
  size?: 'default' | 'large';
  position?: 'default' | 'center';
  itemClassName?: string;
  containerClassName?: string;
  inGameItem?: ReactNode;
}) => {
  return (
    <RewardItemContainer
      size={size}
      position={position}
      className={containerClassName}
    >
      {rewardItem && (
        <PortalCurrencyItemImage
          rewardItem={rewardItem}
          className={cn(
            {
              'h-full w-full object-bottom': position === 'default',
              'h-2/3 w-2/3 object-center': position === 'center',
            },
            itemClassName
          )}
        />
      )}
      {inGameItem}
    </RewardItemContainer>
  );
};
